import React, { useEffect, useState } from 'react';
import { PreCodeEmbed, ShareSocialListWrapper, SocialItem, SocialItemsWrapper } from './ShareSocialList.styled';
import { FormattedMessage as Translate } from "react-intl";

interface ShareSocialListProps {
  shareId: string;
}

interface ISocialShare {
  icon: string;
  onClick: () => void;
  label: React.ReactNode,
}


function ShareSocialList({shareId}: ShareSocialListProps) {

  const [showEmbedCode, setShowEmbedCode] = useState<boolean>(false);
  const playerUrl = `https://player.vod2.infomaniak.com/share/${shareId}`
  const iframeCode = `<iframe src="player.vod2.infomaniak.com/embed/${shareId}" allowFullScreen></iframe>`

  const shareSocialArray: ISocialShare[] = [
    {
      label: <Translate id="Facebook"/>,
      icon: '/assets/images/icons/logo-facebook.svg',
      onClick: () => window.open(`https://www.facebook.com/sharer/sharer.php?u=${playerUrl}`, 'facebook-popup', 'height=600,width=600')
    },
    {
      label: <Translate id="Whatsapp"/>,
      icon: '/assets/images/icons/whatsapp-logo.svg',
      onClick: () => window.open(`whatsapp://send?text=${playerUrl}`)
    },
    {
      label: <Translate id="X"/>,
      icon: '/assets/images/icons/logo_X.svg',
      onClick: () => window.open(`https://twitter.com/share?url=${playerUrl}`, 'twitter-popup', 'height=600,width=600'),
    },
    {
      label: <Translate id="LinkedIn"/>,
      icon: '/assets/images/icons/linkedin-logo.svg',
      onClick: () => window.open(`https://www.linkedin.com/shareArticle?mini=true&url=${playerUrl}`, 'linkedin-popup', 'height=600,width=600'),
    },
    {
      label: <Translate id="Integrer"/>,
      icon: '/assets/images/icons/code-browser.svg',
      onClick: () => {
        setShowEmbedCode(!showEmbedCode);
      },
    }
  ];


  useEffect(() => {



  }, [shareId])


  return (
    <ShareSocialListWrapper data-testid="ShareSocialList">
      <SocialItemsWrapper>
        {
          shareSocialArray.map((social, index) => (
            <SocialItem key={index} onClick={social.onClick}>
              <img src={social.icon} alt={'social icons'}/>
              {social.label}
            </SocialItem>
          ))
        }
      </SocialItemsWrapper>

      {showEmbedCode &&
        <PreCodeEmbed>
          {iframeCode}
        </PreCodeEmbed>
      }
    </ShareSocialListWrapper>
  )

}


export default ShareSocialList;
